module.exports = {
	danish: require("./da").stopwords,
	dutch: require("./nl").stopwords,
	english: require("./en").stopwords,
	french: require("./fr").stopwords,
	galician: require("./gl").stopwords,
	german: require("./de").stopwords,
	italian: require("./it").stopwords,
	polish: require("./pl").stopwords,
	portuguese: require("./pt").stopwords,
	russian: require("./ru").stopwords,
	spanish: require("./es").stopwords,
	swedish: require("./se").stopwords
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/keyword-extractor/lib/stopwords/stopwords.js
 ** module id = 2980
 ** module chunks = 0
 **/